import axios from "axios";

const httpClient = axios.create({
  // baseURL: "http://localhost:9731/api/v1/admin", // staging server
  baseURL: "http://13.50.10.46/api/v1/admin", // local server
});

// Request interceptor
httpClient.interceptors.request.use(
  (request) => {
    // Do something with the request config (e.g., add headers, authentication token)
    // For example:
    var token = window.localStorage.getItem("CardToken");
    const resetPassToken = window.localStorage.getItem("verifyToken");
    if (resetPassToken !== null && resetPassToken !== "") {
      token = resetPassToken;
    }

    if (token) {
      token = JSON.parse(token);
    }
    request.headers["Authorization"] = `Bearer ${token}`;

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
httpClient.interceptors.response.use(
  (response) => {
    // Do something with the response data
    return response;
  },
  (error) => {
    // Do something with the response error (e.g., error handling, logging)
    return Promise.reject(error);
  },
);

export default httpClient;
